'use client';

import type { ReactElement } from 'react';
import { Ccontainer } from '@/components/ui/Ccontainer';
import { Chackerheader } from '@/components/ui/Chackerheader';
import { FooterState } from './footerModels';
import type { FooterHeaderModel } from './footerModels';
import { CfooterActionRow } from './CfooterActionRow';

export interface CfooterActionsProps {
  vh: number;
  footerState: FooterState;
  headerModel: FooterHeaderModel;
  privacyHref: string;
  termsHref: string;
  onRevealEmail: () => void;
  onAboutUs: () => void;
  onPrivacy: () => void;
  onTerms: () => void;
}

export function CfooterActions({
  vh,
  footerState,
  headerModel,
  privacyHref,
  termsHref,
  onRevealEmail,
  onAboutUs,
  onPrivacy,
  onTerms,
}: CfooterActionsProps): ReactElement {

  return (
      <Ccontainer
        display="flex"
        flexDirection="column"
        alignItems="center"
        justifyContent="flex-end"
        style={{
          width: '100%',
          height: vh * 100,
          gap: 24,
          paddingBottom: 60,
        }}
      >
        <Chackerheader
          text={headerModel.text}
          fontSize={headerModel.fontSize}
          gap={8}
          fontWeight={headerModel.fontWeight}
          temper={headerModel.temper}
          color={headerModel.color}
          opacity={headerModel.opacity}
        />

        <CfooterActionRow
          footerState={footerState}
          privacyHref={privacyHref}
          termsHref={termsHref}
          onRevealEmail={onRevealEmail}
          onAboutUs={onAboutUs}
          onPrivacy={onPrivacy}
          onTerms={onTerms}
        />
      </Ccontainer>
  );
}
